import { LegKickGameOver } from './LegKickGameOver.tsx';
import { LegKickHud } from './LegKickHud.tsx';
import { LegKickPause } from './LegKickPause.tsx';

/** Входной адаптер (in): DOM-HUD для leg-kick; скелет и мишени — в `CanvasRenderer`. */
export function LegKickTvOverlays() {
  return (
    <>
      <LegKickHud />
      <LegKickPause />
      <LegKickGameOver />
    </>
  );
}
